import { graphql } from 'react-relay';

export const visitorInfoPageFragment = graphql`
  fragment VisitorInfoPage_page on VisitorInfoPage {
    breadcrumbs {
      ...Breadcrumb_data
    }
    confirmLabel
    country {
      options {
        code
        label
      }
      title
    }
    visitorType {
      options {
        code
        description
        label
      }
      title
    }
    id
    path
    disclaimer
    explanation
    language
    name
    pageTitle
    rejectedTitle
    rejectedText
    rejectedButtonLabel
    rejectLabel
  }
`;
